import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import "core-js/modules/es.regexp.exec.js";
import _URLSearchParams from "@babel/runtime-corejs3/core-js-stable/url-search-params";
import _URL from "@babel/runtime-corejs3/core-js-stable/url";
import { useEffect } from "react";
import { useAuthInternal } from "./AuthContext";
import { mergeParamsIfExists } from "./mergeParams";
export var SilentLogin = function () {
  var oidc = useAuthInternal().oidc;
  return useEffect(function () {
    if (!oidc.tokens) {
      var _ref,
        playCallbackAsync = (_ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
          var _queryParams$get, extras, queryParams;
          return _regeneratorRuntime.wrap(function (_context) {
            for (;;) switch (_context.prev = _context.next) {
              case 0:
                return extras = {}, (queryParams = new _URLSearchParams(new _URL(window.location.href).search)).forEach(function (value, key) {
                  "state" !== key && "scope" !== key && (extras[key] = value);
                }), _context.next = 5, oidc.loginAsync(void 0, mergeParamsIfExists("JUTRO_AUTH_LOGIN_QUERY_EXTRAS", extras), !0, null !== (_queryParams$get = queryParams.get("scope")) && void 0 !== _queryParams$get ? _queryParams$get : "");
              case 5:
              case "end":
                return _context.stop();
            }
          }, _callee);
        })), function () {
          return _ref.apply(this, arguments);
        });
      playCallbackAsync();
    }
  }, [oidc]), null;
};